<template>
  <el-card class="custom-card" shadow="never">
    <el-form v-loading="loading" ref="dataForm" :model="dataForm" :rules="rules" label-position="top" style="width: 50%;margin-left: auto;margin-right: auto;">
      <el-form-item label="商户号" prop="MachId">
        <el-input :disabled="dataForm.MaId" v-model="dataForm.MachId" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="商户名称" prop="MachName">
        <el-input v-model="dataForm.MachName" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="过期时间" prop="ExpiredTime">
        <el-date-picker
          v-model="dataForm.ExpiredTime"
          style="width: 100%;"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"/>
      </el-form-item>
      <el-form-item label="商户支付密钥" prop="Paysignkey">
        <el-input v-model="dataForm.Paysignkey" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="证书文件" prop="CertPath">
        <file-upload ref="upload-CertPath" api-url="https://admin.huabendian.cn/api/common/uploadCert" style="width: 100%;" accept=".p12" @change="handleUploadChange($event, 'CertPath')">
          <template slot="tip">
            请上传.p12文件
          </template>
        </file-upload>
      </el-form-item>
      <el-form-item>
        <el-button round type="info" @click="cancel">取消</el-button>
        <el-button round type="primary" @click="submit('dataForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import { addMachInfo, editMachInfo } from './api'
import FileUpload from '@/components/FileUpload/index4'
export default {
  components: { FileUpload },
  data() {
    return {
      baseUrl: process.env.BASE_API,
      loading: false,
      dataForm: {
        'MaId': 0,
        'MachId': undefined,
        'MachName': undefined,
        'ExpiredTime': undefined,
        'Paysignkey': undefined,
        CertPath: undefined
      },
      rules: {
        MachId: [
          { required: true, message: '请输入' }
        ],
        MachName: [
          { required: true, message: '请输入' }
        ],
        ExpiredTime: [
          { required: true, message: '请输入' }
        ],
        Paysignkey: [
          { required: true, message: '请输入' }
        ],
        CertPath: [
          { required: true, message: '请上传证书文件' }
        ]
      }
    }
  },
  methods: {
    init(row) {
      Object.assign(this.dataForm, row)
      this.$nextTick(() => {
        this.$refs['upload-CertPath'].init(this.dataForm.CertPath ? {
          fileExplainName: this.dataForm.CertPath,
          filePath: this.baseUrl + this.dataForm.CertPath,
          fileId: this.dataForm.CertPath
        } : '')
      })
    },
    handleUploadChange(e, key) {
      console.log(e)
      this.dataForm[key] = e ? e.url : ''
    },
    submit(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          this.loading = true
          console.log('提交')
          // const re = new RegExp(`(?<=${this.baseUrl}).*`, 'g')
          // console.log(re)
          if (this.dataForm.MaId) {
            editMachInfo({ ...this.dataForm, CertPath: this.dataForm.CertPath }).then(res => {
              this.$message.success('操作成功')
              this.cancel()
              this.$emit('refresh')
            }).finally(() => {
              this.loading = false
            })
          } else {
            addMachInfo({ ...this.dataForm, CertPath: this.dataForm.CertPath }).then(res => {
              this.$message.success('操作成功')
              this.cancel()
              this.$emit('refresh')
            }).finally(() => {
              this.loading = false
            })
          }
        }
      })
    },
    cancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>

</style>
